<template>
  <!-- NOTE: white-space: pre-wrap;を指定している要素はDOM上の改行と空白もレンダリングしてしまうため、
  このファイルではそのeslintルールを除外している -->
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <!-- eslint-disable vue/multiline-html-element-content-newline -->
  <div class="ticket--connected_multiple">
    <div class="ticket-box">
      <span v-if="isTicketDisabled" class="tag">{{ disabledMessage }}</span>
      <span class="ticket-image">
        <ImgLazy
          :image-url="imageUrl"
          :alt-text="itemName"
          aspect-ratio="1"
          :width="80"
          :height="80"
          class="ticket-image-container"
        />
      </span>
      <div class="ticket-info">
        <span class="ticket__brand--small">{{ brandName }}</span>
        <span class="ticket__item-name">{{ itemName }}</span>
        <!-- NOTE: prettierがpタグのスタイルを強制するため、このpタグだけはinline要素として扱うように指定 -->
        <!-- display: inline -->
        <span v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">{{
          itemSkuName
        }}</span>
        <p class="ticket__item-price">
          <span class="ticket__item-price__price">
            ¥{{ price.toLocaleString() }}
          </span>
          <span class="ticket__item-price__including-tax">{{
            displayIncludingTax
          }}</span>
        </p>
        <span class="ticket-expired-date">{{ expiredDate }}まで有効</span>
      </div>
    </div>
    <div class="ticket-count">
      <span class="ticket-count__number">枚数： {{ ticketCount }} 枚</span>
    </div>
  </div>
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    expiredDate: {
      type: String,
      required: false,
      default: ''
    },
    isTicketDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    disabledMessage: {
      type: String,
      required: false,
      default: '期限切れ'
    },
    ticketCount: {
      type: Number,
      required: true
    },
    price: {
      type: Number,
      required: true
    }
  },
  computed: {
    isNotEmptyExprirationDate() {
      return this.expiredDate !== ''
    },
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    displayIncludingTax() {
      return this.isIncludingTax ? '税込' : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &-box {
    height: auto;
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image {
    .ticket-image-container {
      border: solid 1px $gray-2;
      border-radius: 8px;
    }
  }

  &-info {
    text-align: left;
    overflow: hidden;
    width: 100%;
    padding: 0 0 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: unset;
    white-space: pre-wrap;
    padding-bottom: 2px;
    color: $black;
    word-wrap: break-word;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: unset;
    white-space: pre-wrap;
    padding-bottom: 12px;
    color: $black;
    padding-bottom: 2px;
    word-wrap: break-word;
  }

  &__brand--small {
    font-size: 1rem;
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: hidden;
    text-overflow: unset;
    white-space: pre-wrap;
    font-weight: bold;
    padding-bottom: 2px;
    word-wrap: break-word;
  }

  &__item-price {
    line-height: 1.6;

    &__price {
      font-size: 1.2rem;
    }

    &__including-tax {
      font-size: 1rem;
    }

    &__shipping-cost {
      font-size: 1rem;
    }
  }

  &-expired-date {
    font-size: 1rem;
    line-height: 2;
    color: $gray-1;
    padding-top: 0;
    text-align: left;
    right: 0;
  }

  &-count {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 12px;

    &__number {
      font-size: 1rem;
      line-height: 1.4;
      color: $gray-1;
      border-bottom: 1px solid $gray-2;
    }
  }
}
</style>
